export default "__VITE_ASSET__DOLZysaU__"